import * as React from 'react';
import type { Maybe, Settings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';

const query = graphql`
    query ExcludedVetspireProviderIdsQuery {
        settings {
            excludeVetspireProviderIds
        }
    }
`;

type ExcludedVetspireProviderIdsQuery = {
    settings: Maybe<Pick<Settings, 'excludeVetspireProviderIds'>>;
};

export default function useExcludedVetspireProviderIds(): readonly string[] {
    const { settings } =
        useStaticQuery<ExcludedVetspireProviderIdsQuery>(query);

    const excludeVetspireProviderIds = (settings?.excludeVetspireProviderIds ??
        '') as string;

    return React.useMemo<readonly string[]>(
        () =>
            excludeVetspireProviderIds
                .split(',')
                .map((providerId) => providerId.trim())
                .filter((providerId) => !!providerId),
        [excludeVetspireProviderIds],
    );
}
